// Compute the visitor's time-of-day phase based on their local clock.
// Used to subtly tint the terminal palette throughout the day.

export type TimePhase = 'night' | 'dawn' | 'day' | 'dusk';

export function currentPhase(date: Date = new Date()): TimePhase {
  const h = date.getHours();
  if (h >= 22 || h < 6) return 'night';
  if (h >= 6 && h < 9) return 'dawn';
  if (h >= 9 && h < 18) return 'day';
  return 'dusk';
}

// CSS class applied to <body> for the active phase.
export function phaseClass(phase: TimePhase): string {
  return `phase-${phase}`;
}

export function applyPhaseToBody(): TimePhase {
  const phase = currentPhase();
  const body = document.body;
  body.classList.remove('phase-night', 'phase-dawn', 'phase-day', 'phase-dusk');
  body.classList.add(phaseClass(phase));
  return phase;
}
